import { DateTime } from 'luxon'
import { PeriodSliceState } from '@/store/insertPeriodSlice'

export function fromISOtoTimestamp(value?: string | null): number | null {
  if (typeof value !== 'string') {
    return null
  }

  const parsedFrom = DateTime.fromISO(value, { zone: 'utc' })
  if (!parsedFrom.isValid) {
    return null
  }

  return parsedFrom.toUnixInteger()
}

export function isSameDay(d1: DateTime, d2: DateTime): boolean {
  const f1 = d1.toFormat('yyyy-LL-dd')
  const f2 = d2.toFormat('yyyy-LL-dd')

  return f1 === f2
}

export function convertPeriodToUnixInteger(
  period: PeriodSliceState['period']
): { end: number; start: number } | null {
  if (!period) return null

  return {
    end: DateTime.fromFormat(period.end, 'yyyy-LL-dd', {
      zone: 'utc',
    }).toUnixInteger(),
    start: DateTime.fromFormat(period.start, 'yyyy-LL-dd', {
      zone: 'utc',
    }).toUnixInteger(),
  }
}

export function convertLocalTimeToUTCTime(time: number) {
  const date = new Date(time)
  const isoDate = DateTime.fromJSDate(date).toISODate()
  if (isoDate === null) {
    throw new Error('cannot convert to isoDate')
  }
  return DateTime.fromISO(isoDate, {
    zone: 'utc',
  }).toUnixInteger()
}

export function toJSDateWithTimezone(datetime: DateTime): Date {
  const isoDate = datetime.toISODate()

  if (isoDate === null) {
    throw new Error('cannot convert datetime to js date')
  }

  return DateTime.fromISO(isoDate, {
    zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }).toJSDate()
}
